import { useFormikContext } from 'formik';

import { optionify } from 'lib/helpers/utility';
import { useStates } from 'lib/hooks/queries/states/useStates';

import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

const PreAuthModalForm = ({ processor, children }) => {
  const formik = useFormikContext();

  const { data: statesData } = useStates();
  const states = optionify(statesData?.states, 'name', 'id');

  const isPayroc = processor === 'payroc';

  const handleFieldChange = async (event) => {
    const { name, value } = event.target;
    const wasAlreadyTouched = formik.touched[name];
    formik.setFieldValue(name, value);

    if (wasAlreadyTouched) {
      await formik.validateField(name);
    }
  };

  const handleSelectChange = async (option) => {
    const wasAlreadyTouched = formik.touched['state'];
    formik.setFieldValue('state', option?.value);

    if (wasAlreadyTouched) {
      await formik.validateField('state');
    }
  };

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex gap-3 sm:flex-col">
        {!isPayroc && (
          <Input
            label="Cardholder Name"
            name="cardholderName"
            value={formik.values.cardholderName}
            onChange={handleFieldChange}
            error={formik.errors.cardholderName}
            className="w-full"
            errorClassName="text-xs"
            required
          />
        )}
        {children}
      </div>
      <div className="flex gap-3 sm:flex-col">
        <Input
          label="Address 1"
          name="address_ln_1"
          value={formik.values.address_ln_1}
          onChange={handleFieldChange}
          className="w-full"
          error={formik.errors.address_ln_1}
          errorClassName="text-xs"
          required
        />
        <Input
          label="Address 2"
          name="address_ln_2"
          value={formik.values.address_ln_2}
          onChange={handleFieldChange}
          className="w-full"
          error={formik.errors.address_ln_2}
          errorClassName="text-xs"
          isOptional
        />
      </div>
      <div className="flex gap-3 sm:flex-col">
        <Input
          label="City"
          name="city"
          value={formik.values.city}
          onChange={handleFieldChange}
          className="w-full"
          error={formik.errors.city}
          errorClassName="text-xs"
          required
        />
        <Select
          label="State"
          name="state"
          value={states?.find((state) => state.value === formik.values.state)}
          onChange={handleSelectChange}
          options={states}
          parentClassName="w-full"
          error={formik.errors.state}
          errorClassName="text-xs"
          required
        />
        <Input
          label="Zip Code"
          name="zip"
          value={formik.values.zip}
          onChange={handleFieldChange}
          className="w-full"
          error={formik.errors.zip}
          errorClassName="text-xs"
          required
        />
      </div>
    </div>
  );
};

export default PreAuthModalForm;
